<script setup>
import { Link } from '@inertiajs/vue3';
</script>

<template>
    <Link :href="'/'">
        <img src="/favicon.png" alt="" width="256" height="256"/>
    </Link>
</template>
